import React from 'react';
import { useTranslation } from 'react-i18next';
import './AnnotationHistoryError.scss';

export interface AnnotationHistoryErrorProps {
  onRetry: () => void;
}

export const AnnotationHistoryError: React.FC<AnnotationHistoryErrorProps> = ({ onRetry }) => {
  const { t } = useTranslation();

  return (
    <div className="annotation-history-error">
      <div className="annotation-history-error__content">
        <h3 className="annotation-history-error__title">{t('sortBy.submenu.annotationHistory.errorTitle')}</h3>
        <p className="annotation-history-error__message">
          {t('sortBy.submenu.annotationHistory.errorMessage1')}
          <br />
          {t('sortBy.submenu.annotationHistory.errorMessage2')}
        </p>
        <button 
          type="button" 
          className="annotation-history-error__button" 
          onClick={onRetry}
        >
          {t('sortBy.submenu.annotationHistory.retryButton')}
        </button>
      </div>
    </div>
  );
};